<template>
    <div class="service--transfer">
        <div class="service--transfer--item">
            <b-row>
                <b-col cols="10" offset="1" :key="transfer_service.details.transfers.length">
                    <div v-if="transfer_service.details.transfers == 0">
                        <div class="d-flex align-items-center">
                            <font-awesome-icon icon="plus" @click="add_transfer_to_service()"/>
                            <small><i>Aggiungi un trasferimento</i></small>
                        </div>
                    </div>
                    <div v-if="transfer_service.length !== 0">
                        <b-row v-for="(transfer_item,transfer_index) in transfer_service.details.transfers" v-bind:key="transfer_service.service_index+'_'+transfer_index">
                            <b-col cols="9">
                                <transfer-item
                                    :transfer="transfer_item"
                                    :service_index="transfer_service.service_index"
                                    :transfer_index="transfer_index"
                                    v-on:removed="/*remove_transfer_from_service*/"
                                    v-on:updated="update_transfer_in_service"
                                />
                            </b-col>
                            <b-col cols="1" class="d-flex align-items-center">
                                <font-awesome-icon icon="plus" @click="add_transfer_to_service()"/>
                                <font-awesome-icon icon="times" @click="remove_transfer_from_service({
                                    transfer_index: transfer_index
                                })"/>
                            </b-col>
                        </b-row>
                    </div>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import { transfer } from '@/quote'
import Transfer from '@/components/blocks/transfer/transfer'
export default {
    name: 'transfer',
    components: {
        'transfer-item': Transfer,
    },
    props: {
        service: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {     
            transfer_service: this.service,
        }
    },
    created()
    {
    },
    mounted() {
    },
    methods:{
        update_service()
        {
            this.$store.commit('set_service', {
                service: this.transfer_service
            })
            this.$nextTick(function(){
                this.transfer_service.details.transfers = this.service.details.transfers
            })
        },
        add_transfer_to_service()
        {
            this.transfer_service.details.transfers.push(transfer)
            this.update_service()
        },
        update_transfer_in_service(payload)
        {
            this.transfer_service.details.transfers[payload.transfer_index] = payload.transfer
            this.update_service()
        },
        remove_transfer_from_service(payload)
        {
            this.transfer_service.details.transfers.splice(payload.transfer_index,1)
            this.update_service()
        },
        refresh_date(value)
        {
            this.transfer_service.details.transfers[value.context.transfer_index].date = value.day
            this.transfer_service.details.transfers[value.context.transfer_index].time = value.hour
            this.transfer_service.details.transfers[value.context.transfer_index].date_time_friendly = value.day + ' - ' + value.hour
            this.update_service()
        }
    },
}
</script>

<style lang="scss">
    .service--transfer
    {
        margin-top:$grid-gutter-width;
        .service--icon
        {
            margin:0;
            height:100%;
            display:flex;
            align-items: center;
            justify-content: flex-start;
        }
        &--item
        {
            width:100%;
        }
        .service--item--add
        {
            margin-top:0;
        }
    }
</style>